<template>
  <div className="col-md-12">
    <div id="elfinder"></div>
  </div>
</template>

<script>
export default {
  name: "PhotosAndDocuments",
  data() {
    return {
      userId: this.$route.query.user_id
    };
  },
  mounted() {
    this.initElfinder();
  },
  methods: {
    async initElfinder() {
      // ✅ Đảm bảo jQuery, jQuery UI và elFinder được tải xong
      await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js");
      await this.loadCSS("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.13.2/themes/smoothness/jquery-ui.min.css");
      await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.13.2/jquery-ui.min.js");
      await this.loadCSS("https://cdnjs.cloudflare.com/ajax/libs/elfinder/2.1.65/css/elfinder.min.css");
      await this.loadScript("https://cdnjs.cloudflare.com/ajax/libs/elfinder/2.1.65/js/elfinder.min.js");

      // ⚡ Chờ thêm một nhịp để jQuery kịp gắn plugin elFinder
      await new Promise(resolve => setTimeout(resolve, 50));

      // ✅ Bảo vệ: nếu elFinder chưa sẵn sàng thì không crash
      if (typeof $.fn.elfinder !== "function") {
        console.error("elFinder chưa load xong — thử lại sau vài mili giây");
        setTimeout(() => this.initElfinder(), 200);
        return;
      }

      // ✅ Khởi tạo elFinder
      $('#elfinder').elfinder({
        url: `${process.env.VUE_APP_API_URL}/elfinder/connector?user_id=${this.userId}`,
        customData: {type: 'invoice'},
        height: 500,
        resizable: false,
        requestType: 'post',
        rememberLastDir: false,
        handlers: {
          init: function (event, elfinderInstance) {
            elfinderInstance.id = 'elfinder';
          }
        },
      });
    },

    loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) return resolve();
        const script = document.createElement("script");
        script.src = src;
        script.async = true;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
      });
    },

    loadCSS(href) {
      return new Promise((resolve) => {
        if (document.querySelector(`link[href="${href}"]`)) return resolve();
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
        resolve();
      });
    }
  }
};
</script>

<style scoped>
.bg-violet {
  background-color: #5E00B6;
}
</style>
